/* eslint-disable @typescript-eslint/no-explicit-any */
import { EventAvailable } from "@mui/icons-material";
import i18n from "../../services/localization-service/i18n";
import { AddAttachmentIcon, AddDiagnositicEventIcon, AddFavoriteIcon, AddMemoIcon, AddRunTicketIcon, AddSetpointIcon, AddValueIcon, ApplyAttributeIcon, ChangeRegisterIcon, ChangeTagTypeIcon, ChangeUomIcon, ConfigurationIcon, CreateFormulaIcon, CreateNewIcon, DeleteIcon, DemandScanIcon, DisableAllAlarmsIcon, DuplicateIcon, EditIcon, EnableAllAlarmsIcon, ExcelIcon, ExportIcon, HideWellHistoryIcon, LinkToSetpointIcon, ManageCommIcon, ManageImagesIcon, MapItIcon, MaximizeGraphIcon, ModifyPermissionsIcon, ModifyPollingScheduleIcon, PDFIcon, RefreshIcon, RemoveAllIcon, RenameIcon, RestoreGraphIcon, RunIcon, SelectAllIcon, SetAsDefaultIcon, ViewDashboardIcon, ViewWellHistoryIcon, WriteDownIcon, ChangeMasterIdentifierIcon, PreferencesIcon, UserAccountIcon, SignOutIcon, ChangeCustomerIcon, RefreshOfflineDataIcon, CallIcon, SearchIcon, OrderIcon, ProductIdeaIcon, ViewUpdatesIcon, SupportAgentIcon, MenuVisibilityIcon, ManageMapFilesIcon } from "./ActionMenuIcons";
import { ActionMenuItem, BaseActionEnum } from "./ActionMenuItem";
import _ from "lodash";


export enum ActionMenuItemCategoryEnum {
    NONE = '',
    POLLING_FUNCTIONS = "Polling Functions",
    DATA_CAPTURE = "Data Capture",
    ALARMING = "Alarming",
    MAP = "Map",
    PROPERTIES = "Properties",
    COMMUNICATIONS = "Communications",

    USER = "User",
    OFFLINEMODE = "Offline Mode",
    SUPPORT = "Support",
    PRODUCT = "Product",
    ORDERS = "Orders",
    LEGAL = "Legal"

}


let order = 0;
export const allActions: ActionMenuItem[] = [{
    id: 'configure',
    label: "Configuration Options",
    icon: ConfigurationIcon,
    action: BaseActionEnum.Configure,
    order: order++,
    subActions: [{
        id: 'create',
        label: i18n.t("actions.createNew"),
        action: BaseActionEnum.CreateNew,
        icon: CreateNewIcon,
        order: 1,
        //dividerBefore: true,
    }, {
        id: "edit",
        label: i18n.t("actions.edit"),
        icon: EditIcon,
        action: BaseActionEnum.Edit,
        order: 2,
        dividerAfter: true
    }, {
        id: 'permission',
        label: i18n.t("actions.modifyPermissions"),
        action: BaseActionEnum.ModifyPermissions,
        icon: ModifyPermissionsIcon,
        order: 3
    }, {
        id: 'defaults',
        label: i18n.t("actions.setAsDefault"),
        action: BaseActionEnum.SetAsDefault,
        icon: SetAsDefaultIcon,
        order: 4
    }, {
        id: 'duplicate',
        label: i18n.t("actions.duplicate"),
        action: BaseActionEnum.Duplicate,
        icon: DuplicateIcon,
        order: 5,
        dividerAfter: true
    }, {
        id: 'rename',
        label: i18n.t("actions.rename"),
        action: BaseActionEnum.Rename,
        icon: RenameIcon,
        order: 6

    }, {
        id: 'delete',
        label: i18n.t("actions.delete"),
        action: BaseActionEnum.Delete,
        icon: DeleteIcon,
        order: 7
    }]
}, {
    id: "create",
    label: i18n.t("actions.createNew"),
    action: BaseActionEnum.CreateNew,
    icon: CreateNewIcon,
    order: order++,
}, {
    id: 'addvalue',
    label: 'Add Value',
    icon: AddValueIcon,
    //pulse: true,
    action: BaseActionEnum.AddValue,
    order: order++
},{
    id: 'export',
    label: i18n.t("actions.export"),
    icon: ExportIcon,
    action: BaseActionEnum.Export,
    order: order++,
    subActions: [{
        id: 'excel',
        label: i18n.t("actions.excel"),
        action: BaseActionEnum.Excel,
        icon: ExcelIcon,
        //id: "subaction-0"
        order: 12
    }, {
        id: 'pdf',
        label: i18n.t("actions.pdf"),
        action: BaseActionEnum.PDF,
        icon: PDFIcon,
        //id: "subaction-1"
        order: 13
    }]
},{
    label: i18n.t("actions.refresh"),
    icon: RefreshIcon,
    action: BaseActionEnum.Refresh,
    order: order++,

},{
    label: i18n.t("actions.demandScan"),
    category: ActionMenuItemCategoryEnum.POLLING_FUNCTIONS,
    icon: DemandScanIcon,
    action: BaseActionEnum.DemandScan,
    order: order++,
},{
    label: i18n.t("actions.writeDown"),
    category: ActionMenuItemCategoryEnum.POLLING_FUNCTIONS,
    icon: WriteDownIcon,
    action: BaseActionEnum.WriteDown,
    order: order++,
},{
    label: i18n.t("actions.modifyPollingSchedule"),
    category: ActionMenuItemCategoryEnum.POLLING_FUNCTIONS,
    icon: ModifyPollingScheduleIcon,
    action: BaseActionEnum.ModifyPollingSchedule,
    order: order++,
},{
    label: i18n.t("actions.addMemo"),
    category: ActionMenuItemCategoryEnum.DATA_CAPTURE,
    icon: AddMemoIcon,
    action: BaseActionEnum.AddMemo,
    order: order++,
},{
    id: "addeventaction",
    label: i18n.t("actions.addEvent"),
    category: ActionMenuItemCategoryEnum.DATA_CAPTURE,    
    icon: () => <EventAvailable />,
    action: BaseActionEnum.AddEvent,
    order: order++,
    subActions: [{
        label: i18n.t("actions.addDiagnosticEvent"),
        category: ActionMenuItemCategoryEnum.DATA_CAPTURE,    
        action: BaseActionEnum.AddDiagnositicEvent,
        icon: AddDiagnositicEventIcon,
        order: 8
    }, {
        label: i18n.t("actions.addWaterLossEvent"),
        category: ActionMenuItemCategoryEnum.DATA_CAPTURE,    
        action: BaseActionEnum.AddWaterLossEvent,
        order: 9
    }]

// here a value entry WTF?

},{
    label: i18n.t("actions.addRunTicket"),
    category: ActionMenuItemCategoryEnum.DATA_CAPTURE,    
    icon: AddRunTicketIcon,
    action: BaseActionEnum.AddRunTicket,
    order: order++,
},{
    label: i18n.t("actions.addAttachment"),
    category: ActionMenuItemCategoryEnum.DATA_CAPTURE,        
    icon: AddAttachmentIcon,
    action: BaseActionEnum.AddAttachment,
    order: order++,
},{
    label: i18n.t("actions.addDiagnosticEvent"),
    category: ActionMenuItemCategoryEnum.DATA_CAPTURE,        
    icon: AddDiagnositicEventIcon,
    action: BaseActionEnum.AddDiagnositicEvent,
    order: order++,
// @@foo what about these ?? Add Value Entry
// Add Form Data

},{
    label: i18n.t("actions.disableAllAlarms"),
    category: ActionMenuItemCategoryEnum.ALARMING,
    icon: DisableAllAlarmsIcon,
    action: BaseActionEnum.DisableAllAlarms,
    order: order++,
}, {
    label: i18n.t("actions.enableAllAlarms"),
    category: ActionMenuItemCategoryEnum.ALARMING,
    icon: EnableAllAlarmsIcon,
    action: BaseActionEnum.EnableAllAlarms,
    order: order++,
},{
    label: i18n.t("actions.addSetpoint"),
    category: ActionMenuItemCategoryEnum.ALARMING,
    icon: AddSetpointIcon,
    action: BaseActionEnum.AddSetpoint,
    order: order++,
},{
    label: i18n.t("actions.linkToSetpoint"),
    category: ActionMenuItemCategoryEnum.ALARMING,
    icon: LinkToSetpointIcon,
    action: BaseActionEnum.LinkToSetpoint,
    order: order++,
},{

    id: "mapit",
    label: i18n.t("actions.mapIt"),
    category: ActionMenuItemCategoryEnum.MAP,
    icon: MapItIcon,
    action: BaseActionEnum.MapIt,
    order: order++,
}, {
    label: i18n.t("actions.applyAttribute"),
    category: ActionMenuItemCategoryEnum.PROPERTIES,
    icon: ApplyAttributeIcon,
    action: BaseActionEnum.AddAttribute,
    order: order++,
},{
    label: i18n.t("actions.changeTagType"),
    category: ActionMenuItemCategoryEnum.PROPERTIES,    
    icon: ChangeTagTypeIcon,
    action: BaseActionEnum.ChangeTagType,
    order: order++,
    
},{
    label: i18n.t("actions.createFormula"),
    category: ActionMenuItemCategoryEnum.PROPERTIES,        
    icon: CreateFormulaIcon,
    action: BaseActionEnum.CreateFormula,
    order: order++,
},{
    label: i18n.t("actions.changeRegister"),
    category: ActionMenuItemCategoryEnum.PROPERTIES,    
    icon: ChangeRegisterIcon,
    action: BaseActionEnum.ChangeRegister,
    order: order++,
},{
    label: i18n.t("actions.changeUom"),
    category: ActionMenuItemCategoryEnum.PROPERTIES,        
    icon: ChangeUomIcon,
    action: BaseActionEnum.ChangeUom,
    order: order++,
},{
    label: i18n.t("actions.changeMasterIdentifier"),
    category: ActionMenuItemCategoryEnum.PROPERTIES,        
    icon: ChangeMasterIdentifierIcon,
    action: BaseActionEnum.ChangeMasterIdentifier,
    order: order++,
},{
    id: 'gotowell',
    label: i18n.t("actions.goToWellDetails"),
    action: BaseActionEnum.GoToWellDetails,
    order: order++,
},{
    order: order++,
    label: i18n.t("wellReview.viewDashboard"),
    icon: ViewDashboardIcon,
    action: BaseActionEnum.ViewDashboard
}, {
    order: order++,
    label: i18n.t("wellReview.viewHistory"),
    icon: ViewWellHistoryIcon,
    action: BaseActionEnum.ViewWellHistory
}, {
    order: 0,
    label: i18n.t("wellReview.hideHistory"),
    icon: HideWellHistoryIcon,
    action: BaseActionEnum.HideWellHistory
       
},{
    order: order++,
    label: i18n.t("wellReview.maximizeGraph"),
    icon: MaximizeGraphIcon,
    action: BaseActionEnum.MaximizeGraph
}, {
    order: order++,
    label: i18n.t("wellReview.restoreGraph"),
    icon: RestoreGraphIcon,
    action: BaseActionEnum.RestoreGraph
},{
    id: 'manage',
    label: i18n.t("actions.manageImages"),
    icon: ManageImagesIcon,
    action: BaseActionEnum.ManageImages,
    order: order++,
},{
    id: 'managemapfiles',
    label: i18n.t("actions.manageMapFiles"),
    icon: ManageMapFilesIcon,
    action: BaseActionEnum.ManageMapFiles,
    order: order++,
}, {
    id: 'run',
    label: i18n.t("actions.run"),
    icon: RunIcon,
    //pulse: true,
    action: BaseActionEnum.Run,
    order: order++
}, {
    id: 'selectall',
    label: i18n.t("buttons.selectAll"),
    icon: SelectAllIcon,
    //pulse: true,
    action: BaseActionEnum.SelectAll,
    order: order++
}, {
    id: 'removeall',
    label: i18n.t("buttons.clearAll"),
    icon: RemoveAllIcon,
    //pulse: true,
    action: BaseActionEnum.RemoveAll,
    order: order++
}, {
    id: "managecomm",
    label: i18n.t("actions.manageComm"),
    category: ActionMenuItemCategoryEnum.COMMUNICATIONS,
    icon: ManageCommIcon,
    action: BaseActionEnum.ManageComm,
    order: order++,
}, {
    label: i18n.t("actions.myProfile"),
    helpText: i18n.t("actions.myProfileDesc").toString(),
    category: ActionMenuItemCategoryEnum.USER,
    icon: UserAccountIcon,
    action: BaseActionEnum.MyProfile,
    order: order++,
},{
    label: i18n.t("actions.appPreferences"),
    helpText: i18n.t("actions.appPreferencesDesc").toString(),
    category: ActionMenuItemCategoryEnum.USER,
    icon: PreferencesIcon,
    action: BaseActionEnum.AppPreferences,
    order: order++,
},{
    label: i18n.t("actions.menuVisibility"),
    helpText: i18n.t("actions.menuVisibilityDesc").toString(),
    category: ActionMenuItemCategoryEnum.USER,
    icon: MenuVisibilityIcon,
    action: BaseActionEnum.MenuVisibility,
    order: order++,
},{
    label: i18n.t("actions.changeCustomer"),
    category: ActionMenuItemCategoryEnum.USER,
    icon: ChangeCustomerIcon,
    action: BaseActionEnum.ChangeCustomer,
    order: order++,
}, {
    label: i18n.t("actions.signOut"),
    category: ActionMenuItemCategoryEnum.USER,
    icon: SignOutIcon,
    action: BaseActionEnum.Signout,
    order: order++,
}, {
    label: i18n.t("actions.lastRefresh"),
    category: ActionMenuItemCategoryEnum.OFFLINEMODE,
    action: BaseActionEnum.LastRefresh,
    order: order++,
    
}, {
    label: i18n.t("actions.lastSync"),
    category: ActionMenuItemCategoryEnum.OFFLINEMODE,
    action: BaseActionEnum.LastSync,
    order: order++,
}, {
    label: i18n.t("actions.enableOfflineMode"),
    category: ActionMenuItemCategoryEnum.OFFLINEMODE,
    action: BaseActionEnum.OfflineMode,
    order: order++,
}, {
    label: i18n.t("actions.refreshOfflineData"),
    category: ActionMenuItemCategoryEnum.OFFLINEMODE,
    icon: RefreshOfflineDataIcon,
    action: BaseActionEnum.RefreshOfflineData,
    order: order++,
}, {
    label: i18n.t("actions.contactSupport"),
    helpText: i18n.t("actions.contactSupportDesc").toString(),
    category: ActionMenuItemCategoryEnum.SUPPORT,
    icon: CallIcon,
    action: BaseActionEnum.ContactSupport,
    order: order++,
}, {
    label: i18n.t("actions.searchHelp"),
    category: ActionMenuItemCategoryEnum.SUPPORT,
    icon: SearchIcon,
    action: BaseActionEnum.SearchHelp,
    order: order++,
}, {
    label: i18n.t("actions.getRemoteSupport"),
    category: ActionMenuItemCategoryEnum.SUPPORT,
    icon: SupportAgentIcon,
    action: BaseActionEnum.GetRemoteSupportCode,
    order: order++,
}, {
    label: i18n.t("actions.version"),
    category: ActionMenuItemCategoryEnum.PRODUCT,
    //icon: () => <SwitchAccount />,
    action: BaseActionEnum.Version,
    order: order++,
}, {
    label: i18n.t("actions.recentUpdates"),
    category: ActionMenuItemCategoryEnum.PRODUCT,
    icon: ViewUpdatesIcon,
    action: BaseActionEnum.RecentUpdates,
    order: order++,
}, {
    label: i18n.t("actions.submitProductIdea"),
    category: ActionMenuItemCategoryEnum.PRODUCT,
    icon: ProductIdeaIcon,
    action: BaseActionEnum.SubmitProductIdea,
    order: order++,
}, {
    label: i18n.t("actions.hardwareOrderForm"),
    helpText: i18n.t("actions.hardwareOrderDec").toString(),
    category: ActionMenuItemCategoryEnum.ORDERS,
    icon: OrderIcon,
    action: BaseActionEnum.HardwareOrder,
    order: order++,
}, {
    label: i18n.t("actions.termsAndConditions"),
    category: ActionMenuItemCategoryEnum.LEGAL,
    //icon: () => <SwitchAccount />,
    action: BaseActionEnum.Terms,
    order: order++,
}, {
    label: i18n.t("actions.privacyPolicy"),
    category: ActionMenuItemCategoryEnum.LEGAL,
    //icon: () => <SwitchAccount />,
    action: BaseActionEnum.PrivacyPolicy,
    order: order++,
// BaseActionEnum.OfflineMode
}, {
    label: i18n.t("actions.appPreferences"),
    category: ActionMenuItemCategoryEnum.LEGAL,
    icon: () => PreferencesIcon,
    action: BaseActionEnum.PrivacyPolicy,
    order: order++,
}, {
    id: "addfavorite",
    label: i18n.t("actions.addFavorite"),
    icon: AddFavoriteIcon,
    action: BaseActionEnum.Favorite,
    order: order + 10,  // try to force always last
}

];

export function getActionMenuItems(actionEnums: BaseActionEnum[]) {
    const defaultActions = allActions.reduce((result: ActionMenuItem[], currentValue) => { 

        if (actionEnums.find(o => o === currentValue.action)) {
            result.push(currentValue);
        }

        return result;
    }, []);

    return _.cloneDeep(defaultActions);

}